var moduleMap = {
	"./AccMainApp": () => {
		return Promise.all([__webpack_require__.e(345), __webpack_require__.e(273), __webpack_require__.e(314), __webpack_require__.e(369), __webpack_require__.e(288), __webpack_require__.e(802), __webpack_require__.e(380), __webpack_require__.e(977), __webpack_require__.e(442), __webpack_require__.e(678)]).then(() => (() => ((__webpack_require__(9124)))));
	},
	"./Hook": () => {
		return Promise.all([__webpack_require__.e(273), __webpack_require__.e(288), __webpack_require__.e(802), __webpack_require__.e(995)]).then(() => (() => ((__webpack_require__(5995)))));
	},
	"./Store": () => {
		return Promise.all([__webpack_require__.e(288), __webpack_require__.e(802), __webpack_require__.e(507)]).then(() => (() => ((__webpack_require__(4507)))));
	},
	"./GlobalAlert": () => {
		return Promise.all([__webpack_require__.e(345), __webpack_require__.e(288), __webpack_require__.e(802), __webpack_require__.e(380), __webpack_require__.e(680), __webpack_require__.e(775)]).then(() => (() => ((__webpack_require__(6775)))));
	},
	"./StandardError": () => {
		return Promise.all([__webpack_require__.e(345), __webpack_require__.e(273), __webpack_require__.e(288), __webpack_require__.e(380), __webpack_require__.e(680), __webpack_require__.e(367)]).then(() => (() => ((__webpack_require__(5367)))));
	},
	"./PageNotFound": () => {
		return Promise.all([__webpack_require__.e(345), __webpack_require__.e(273), __webpack_require__.e(288), __webpack_require__.e(380), __webpack_require__.e(680), __webpack_require__.e(386)]).then(() => (() => ((__webpack_require__(1783)))));
	},
	"./Header": () => {
		return Promise.all([__webpack_require__.e(345), __webpack_require__.e(273), __webpack_require__.e(288), __webpack_require__.e(802), __webpack_require__.e(380), __webpack_require__.e(680), __webpack_require__.e(442), __webpack_require__.e(470)]).then(() => (() => ((__webpack_require__(4436)))));
	},
	"./HeaderSheet": () => {
		return Promise.all([__webpack_require__.e(345), __webpack_require__.e(273), __webpack_require__.e(288), __webpack_require__.e(802), __webpack_require__.e(380), __webpack_require__.e(680), __webpack_require__.e(592)]).then(() => (() => ((__webpack_require__(592)))));
	},
	"./Footer": () => {
		return Promise.all([__webpack_require__.e(345), __webpack_require__.e(273), __webpack_require__.e(288), __webpack_require__.e(802), __webpack_require__.e(380), __webpack_require__.e(680), __webpack_require__.e(912)]).then(() => (() => ((__webpack_require__(8610)))));
	},
	"./Navigator": () => {
		return Promise.all([__webpack_require__.e(345), __webpack_require__.e(273), __webpack_require__.e(314), __webpack_require__.e(288), __webpack_require__.e(802), __webpack_require__.e(380), __webpack_require__.e(680), __webpack_require__.e(977), __webpack_require__.e(899)]).then(() => (() => ((__webpack_require__(899)))));
	},
	"./CookieBanner": () => {
		return Promise.all([__webpack_require__.e(345), __webpack_require__.e(288), __webpack_require__.e(380), __webpack_require__.e(680), __webpack_require__.e(464)]).then(() => (() => ((__webpack_require__(6464)))));
	},
	"./ServiceCommon": () => {
		return __webpack_require__.e(802).then(() => (() => ((__webpack_require__(6802)))));
	},
	"./ServiceUser": () => {
		return __webpack_require__.e(147).then(() => (() => ((__webpack_require__(7147)))));
	},
	"./SharedI18n": () => {
		return Promise.all([__webpack_require__.e(273), __webpack_require__.e(369), __webpack_require__.e(288), __webpack_require__.e(802), __webpack_require__.e(652)]).then(() => (() => ((__webpack_require__(2652)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});